// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"fb771931","845":"4c395ced"}[chunkId] + ".chunk.js";
};